<template>
  <div>
    <div class="d-flex mb-1">
      <v-btn
        class="mx-auto align-content-center px-2"
        color="white"
        style="border: 2px solid white"
        rounded
        outlined
        @click="showMore = !showMore"
      >
        مشاهده اطلاعات
        <img
          v-if="showMore"
          src="/media/arrow-thin-chevron-bottom-icon.svg"
          width="15"
          class="mx-auto mr-2"
          style="transform: rotate(180deg); transition: all 0.5s"
          alt=""
        />
        <img
          v-else
          src="/media/arrow-thin-chevron-bottom-icon.svg"
          width="15"
          class="mx-auto mr-2"
          style="transition: 0.3s all"
          alt=""
        />
      </v-btn>
    </div>

    <v-card
      v-show="showMore"
      flat
      :style="{ background: value.pallete.headColor }"
      dark
      color="primary"
      class="rounded-0 pb-1 pt-4 mb-0"
      v-intersect="onIntersect"
    >
      <div class="px-5 py-0 my-0">
        <div
          v-if="getHeaderImg"
          key="logo"
          class="white mb-3 rounded-circle header-img-bg"
        >
          <div
            class="bg-filter"
            :style="{ backgroundImage: `url(${getHeaderImg})` }"
          />
          <img :src="getHeaderImg" alt="" />
        </div>
        <p class="text-justify" style="white-space: pre-line">
          {{ value.organizationName }}
        </p>
        <p class="text-justify" style="white-space: pre-line">
          {{ value.subtitle }}
        </p>
      </div>
      <v-row
        :style="{ color: value.pallete.textColor }"
        no-gutters
        v-for="(item, i) in value.extraFields"
        :key="i"
        class="mt-0 pt-0 px-5"
      >
        <v-col
          :style="{ color: value.pallete.textColor }"
          cols="12"
          class="d-flex mt-0 pt-0 align-start"
          :tag="extraIsLink(item) ? 'a' : 'div'"
          target="_blank"
          :href="extraIsLink(item) ? fixLink(item.link) : false"
          :class="{ 'link-tag': extraIsLink(item) }"
        >
          <span v-if="item.icon" class="text-no-wrap me-1">
            <v-icon :style="{ color: value.pallete.textColor }">{{
              item.icon
            }}</v-icon>
            :
          </span>
          <pre
            :style="{ color: value.pallete.textColor }"
            v-if="item.value"
            class="text-justify mb-0 mt-1"
            style="white-space: pre-line"
            :key="i"
            v-html="item.value"
            :class="extraIsLink(item) ? 'link-tag' : ''"
          />
        </v-col>
        <v-col cols="12" class="py-2">
          <v-divider class="my-0" v-show="i + 1 < value.extraFields.length" />
        </v-col>
      </v-row>

      <v-card-text
        v-if="value.website"
        class="font-size-h5 d-flex mt-0 pt-0 flex-column"
      >
        <a :href="value.website" class="text-white">
          <v-icon class="ml-auto">mdi-web</v-icon>
          {{ value.website }}
        </a>
      </v-card-text>

      <v-card-text
        v-if="value.aboutUs"
        class="font-size-h5 d-flex mt-0 pt-3 flex-column"
      >
        <p class="text-justify" style="white-space: pre-line">
          {{ value.aboutUs }}
        </p>
      </v-card-text>
      <p ref="btom"></p>
    </v-card>
  </div>
</template>

<script>
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";

export default {
  name: "showMoreCatalog",
  components: { ShowInfo },
  props: {
    value: {},
  },
  computed: {
    getHeaderImg() {
      return (
        this.value.photo.profile ?? this.value.photo.headBackground ?? false
      );
    },
  },
  data: () => ({
    isIntersecting: false,
    showMore: false,
  }),
  watch: {
    isIntersecting(val) {
      this.$emit("intersecting", val);
    },
    value() {
      this.$emit("input", this.value);
    },
    showMore(val) {
      if (val) {
        this.$nextTick(() => {
          const btomElement = this.$refs.btom;
          if (btomElement) {
            btomElement.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
        });
      }
    },
  },

  methods: {
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting;
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
  },
};
</script>

<style scoped>
.inside-btn {
  box-shadow: rgba(240, 46, 170, 0.4) -5px 5px,
    rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px,
    rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;
}

.header-img-bg {
  display: flex;
  justify-content: right;
  width: 80px;
  height: 80px;
  border: 2px solid white;
  position: relative;
  overflow: hidden;
}

.header-img-bg >>> .bg-filter {
  position: absolute;
  inset: -4px;
  background-size: cover;
  filter: blur(1.8px) brightness(1.3) opacity(0.8);
}

.header-img-bg >>> img {
  position: relative;
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
}
</style>
